/**
 * Static (hardcoded) proposal content for governance voting.
 * Live data (votes, dates, status) comes from the governance websocket (GovernanceData).
 * This file provides titles, descriptions, section content, and the transform to vote cards.
 */
import { convertToKAndM } from 'ui-kit';
export const voteProposalsContent = {
    'AIP-1': {
        title: 'Proposal to Enhance AlphaFi Airdrop System',
        author: '0x1a1cfbf5f6f22510818808268237413d458bbe3ade5281c585d78d12583bea43',
        explorerLink: 'https://suiscan.xyz/mainnet/object/0x733e0850cfbe2b269202956d725718ad8577555af56271d98c3cc030f152ed0a',
        defaultDates: {
            created_at: '1743261900',
            start_time: '1743434700',
            end_time: '1744039500',
        },
        description: '',
        sections: [
            {
                title: 'Summary',
                items: [
                    {
                        text: "This proposal seeks approval from ALPHA holders to upgrade the existing airdrop system by introducing stSUI rewards in addition to ALPHA. While the current fee structure remains unchanged, 50% of all non-ALPHA tokens accumulated in the Reserve Fund will now be converted to stSUI and distributed to stakers during the regular 100-day airdrop cycle. This change is designed to increase rewards for stakers, improve capital efficiency, and deepen AlphaFi's alignment with the Sui ecosystem.",
                    },
                ],
            },
            {
                title: 'Current Fee Allocation (No Changes):',
                items: [
                    { text: '50% - Buyback and distributed to ALPHA stakers.' },
                    { text: '20% - Reserve fund.' },
                    { text: '5% - ALPHA Liquidity Pools.' },
                    { text: '25% - Team.' },
                ],
            },
            {
                title: 'Proposed Enhancement: Active Use of Reserve Fund',
                items: [
                    {
                        text: '50% of all non-ALPHA tokens in the Reserve Fund ([Click here to view on Suiscan](https://suiscan.xyz/mainnet/account/0x733e0850cfbe2b269202956d725718ad8577555af56271d98c3cc030f152ed0a)) will be converted to stSUI.',
                    },
                    { text: 'Current estimated balance of stSUI: 391,000 USD.' },
                    {
                        text: 'Converted stSUI will be distributed proportionally to users during every 100-day airdrop cycle.',
                    },
                    {
                        text: "stSUI rewards will be proportional to a user's share of locked ALPHA.",
                        subItems: [
                            "Example: If you hold 1% of all locked ALPHA, you'll receive 1% of the stSUI distributed.",
                        ],
                    },
                ],
            },
            {
                title: 'If the Proposal Passes',
                items: [
                    {
                        text: 'The enhanced airdrop system will be implemented starting from the next airdrop cycle: 3:25 PM UTC, 19 April 2025.',
                    },
                    {
                        text: 'Starting from this cycle:',
                        subItems: [
                            'ALPHA airdrop: Distributed as usual and automatically locked.',
                            "stSUI rewards: Will be sent directly to users' wallets, providing immediate access",
                        ],
                    },
                ],
            },
            {
                title: 'Rationale for Proposal',
                items: [
                    {
                        text: 'Boosted Rewards Now: stSUI offers users a boosted yield alongside ALPHA rewards.',
                    },
                    { text: 'Better Use of Fees: Unlocks dormant Reserve Fund assets to reward stakers.' },
                    { text: 'Stronger Incentive to Lock: Reinforces 100-day lock as the best way to earn.' },
                    { text: 'Increased User Rewards: Enhances rewards without changing fee splits.' },
                    {
                        text: 'Strategic Sui Alignment: Incorporates stSUI benefits while keeping ALPHA central.',
                    },
                ],
            },
            {
                title: 'Voting Details',
                items: [
                    {
                        text: 'Vote Options:',
                        subItems: [
                            'YES – Approve the enhanced airdrop system (stSUI + ALPHA).',
                            'NO – Keep the current airdrop system (ALPHA-only)',
                        ],
                    },
                    {
                        text: 'Voting Power: Based on the amount of ALPHA staked as of 3:25 PM UTC, 30 March 2025.',
                    },
                    { text: 'Deadline: Voting will close as of 3:25 PM UTC, 7 April 2025.' },
                    {
                        text: 'Minimum Participation: 1,000,000 ALPHA must vote for the proposal to be valid.',
                    },
                    { text: 'Approval Requirement: At least 60% YES votes.' },
                    {
                        text: 'Team Clause: Team-held locked ALPHA will not participate in this vote.',
                    },
                ],
            },
            {
                title: 'Final Notes',
                items: [
                    {
                        text: "This proposal introduces meaningful, sustainable upgrades to the reward model without altering the protocol's core economics. By converting idle assets into stSUI, we increase utility and value for long-term stakers.",
                    },
                    {
                        text: 'If you have any questions or would like more information on this proposal, feel free to reach out to us:',
                    },
                    { text: 'Websites: [alphafi.xyz](https://alphafi.xyz) & [stsui.com](https://stsui.com)' },
                    { text: 'Twitter: [@AlphaFiSUI](https://x.com/AlphaFiSUI)' },
                    { text: 'Telegram: [@AlphaFiSui](https://t.me/AlphaFiSui)' },
                ],
            },
        ],
    },
    'AIP-2': {
        title: 'Proposal to Deploy Reserve ALPHA as Boosted Ecosystem Rewards',
        author: '0x1a1cfbf5f6f22510818808268237413d458bbe3ade5281c585d78d12583bea43',
        explorerLink: 'https://suiscan.xyz/mainnet/object/0xab41bef61a7a80ba6428a85a82a55a9682f9febb5a14c6267e6aeb81e5133369',
        defaultDates: {
            created_at: '1744631460',
            start_time: '1744644300',
            end_time: '1744903500',
        },
        description: '',
        sections: [
            {
                title: 'Summary',
                items: [
                    {
                        text: 'This proposal seeks approval from ALPHA holders to unlock all ALPHA currently held in the Reserve Fund (currently 520,000 ALPHA) and distribute it as additional rewards across the AlphaFi ecosystem for the next 100-day cycle, beginning 19 April 2025.',
                    },
                    { text: '' },
                    {
                        text: 'This temporary reward boost aims to:',
                        subItems: [
                            'Strengthen user incentives across the ALPHA ecosystem.',
                            'Attract new liquidity to AlphaFi ahead of upcoming protocol milestones.',
                            'Drive deeper ecosystem engagement with no change to the existing fee structure.',
                        ],
                    },
                ],
            },
            {
                title: 'Current Reserve Fund Status',
                items: [
                    { text: 'Reserve Fund ALPHA Balance: ~520,000 ALPHA.' },
                    {
                        text: 'Reserve Fund Suiscan Address: [@alphareserve](https://suiscan.xyz/mainnet/account/0x5a9fac4148605191b8e0de25a6671ba8008c344c1558bbaac73a947bd6c903b1)',
                    },
                    { text: 'Fee Allocation Policy: No changes to the current 50/20/5/25 split.' },
                ],
            },
            {
                title: 'Proposed Enhancement: Targeted ALPHA Distribution',
                items: [
                    {
                        text: '520,000 ALPHA will be distributed strategically and proportionally across AlphaFi vaults and products over the next 100-day cycle.',
                    },
                    {
                        text: 'The largest share will go towards ALPHA stakers, with the rest going to AlphaFi vaults and the new AlphaFi product launching soon.',
                    },
                ],
            },
            {
                title: 'If the Proposal Passes',
                items: [
                    {
                        text: 'The ALPHA Reserve rewards will begin 19 April 2025, coinciding with the next airdrop cycle.',
                    },
                    { text: 'This one-time campaign will span 100 days, ending 28 July 2025.' },
                ],
            },
            {
                title: 'Rationale for Proposal',
                items: [
                    {
                        text: 'Supercharged Ecosystem Rewards: Temporarily boosts incentives for all user types without altering base emissions.',
                    },
                    {
                        text: 'Efficient Use of Idle Tokens: Unused ALPHA in the Reserve Fund becomes a tool for growth rather than remaining static.',
                    },
                    {
                        text: 'Supports Token Locking: Auto-locking distributed ALPHA aligns long-term incentives.',
                    },
                ],
            },
            {
                title: 'Voting Details',
                items: [
                    {
                        text: 'Vote Options:',
                        subItems: [
                            'YES – Deploy 520,000 ALPHA from the Reserve Fund over the next 100 days as ecosystem rewards.',
                            'NO – Keep the Reserve Fund ALPHA untouched.',
                        ],
                    },
                    { text: 'Voting Power: Based on staked ALPHA at 3:25 PM UTC, 13 April 2025.' },
                    { text: 'Deadline: Vote closes 3:25 PM UTC, 17 April 2025.' },
                    {
                        text: 'Quorum: Minimum 1,000,000 ALPHA must vote for the proposal to be valid.',
                    },
                    { text: 'Approval Requirement: 60% YES votes required for approval.' },
                    { text: 'Team Clause: Team-held locked ALPHA will not vote on this proposal.' },
                ],
            },
            {
                title: 'Final Notes',
                items: [
                    {
                        text: "This proposal offers a strategic, time-bound way to reinvest Reserve Fund assets back into AlphaFi's growth. If passed, it will enhance rewards and increase TVL without altering the tokenomics and max supply of ALPHA of 10M. Questions? Reach us anytime:",
                    },
                    { text: 'Websites: [alphafi.xyz](https://alphafi.xyz) & [stsui.com](https://stsui.com)' },
                    { text: 'Twitter: [@AlphaFiSUI](https://x.com/AlphaFiSUI)' },
                    { text: 'Telegram: [@AlphaFiSui](https://t.me/AlphaFiSui)' },
                ],
            },
        ],
    },
};
/** Build one vote card from static content + websocket proposal. */
function buildOneCard(displayId, objectId, staticContent, proposal, options) {
    var _a, _b, _c, _d, _e;
    const { getIcon, createSubmitVoteHandler, themeName } = options;
    const d = staticContent.defaultDates;
    const redirectIcon = themeName === 'dark' ? getIcon('whiteExternalLinkIcon') : getIcon('blackExternalLinkIcon');
    const icons = {
        upcoming: getIcon('flagIcon'),
        active: getIcon('timeIcon'),
        passed: getIcon('roundedGreenCheckIcon'),
        redirect: redirectIcon,
        voteRecorded: getIcon('roundedGrayCheckIcon'),
        voteOptions: getIcon('roundedGrayCheckIcon'),
        no: getIcon('cancelIcon'),
    };
    const vr = proposal.voting_result;
    const forVotes = Number((_a = vr.for_votes) !== null && _a !== void 0 ? _a : vr.yes_votes) || 0;
    const againstVotes = Number((_b = vr.against_votes) !== null && _b !== void 0 ? _b : vr.no_votes) || 0;
    const abstainVotes = Number(vr.abstain_votes) || 0;
    const createdDate = (_c = proposal.created_at) !== null && _c !== void 0 ? _c : d.created_at;
    const startDate = (_d = proposal.start_time) !== null && _d !== void 0 ? _d : d.start_time;
    const endDate = (_e = proposal.end_time) !== null && _e !== void 0 ? _e : d.end_time;
    // Check if proposal is active (between start and end time)
    const now = Math.floor(Date.now() / 1000);
    const startTimestamp = Number(startDate);
    const endTimestamp = Number(endDate);
    const isActive = now >= startTimestamp && now <= endTimestamp;
    const voteData = {
        proposal: {
            id: displayId,
            title: staticContent.title,
            author: staticContent.author,
            explorerLink: staticContent.explorerLink,
            createdDate,
            startDate,
            endDate,
            proposalObjectId: objectId,
        },
        content: {
            description: staticContent.description,
            sections: staticContent.sections.map((sec) => ({
                title: sec.title,
                items: sec.items.map((item) => ({ text: item.text, subItems: item.subItems })),
            })),
        },
        voting: {
            isEligible: isActive,
            selectedOption: undefined,
            userVote: undefined,
            voteSuccess: false,
            onOptionChange: undefined,
            onSubmit: createSubmitVoteHandler ? createSubmitVoteHandler(displayId) : () => { },
        },
        results: {
            for: String(forVotes),
            against: String(againstVotes),
            abstain: String(abstainVotes),
            displayFor: forVotes > 0 || againstVotes > 0 ? convertToKAndM(forVotes / 1e9, { decimals: 0 }) : '0',
            displayAgainst: forVotes > 0 || againstVotes > 0
                ? convertToKAndM(againstVotes / 1e9, { decimals: 0 })
                : '0',
            displayAbstain: abstainVotes > 0 ? convertToKAndM(abstainVotes / 1e9, { decimals: 0 }) : '0',
            displayTotal: forVotes > 0 || againstVotes > 0
                ? convertToKAndM((forVotes + againstVotes + abstainVotes) / 1e9, { decimals: 0 })
                : '0',
        },
        display: { listType: 'bullet', boldText: false, marginBottom: true },
        icons: {
            redirect: icons.redirect,
            voteRecorded: icons.voteRecorded,
            voteOptions: icons.voteOptions,
            no: icons.no,
        },
    };
    return {
        proposalId: displayId,
        proposalTitle: staticContent.title,
        proposalStartDate: startDate,
        proposalEndDate: endDate,
        forVotes,
        againstVotes,
        upcomingIcon: icons.upcoming,
        activeIcon: icons.active,
        passedIcon: icons.passed,
        voteData,
    };
}
/** Merge websocket proposals with static content to create vote cards for UI. */
export function buildVoteCards(proposals, options) {
    const staticEntries = Object.entries(voteProposalsContent);
    return proposals
        .map((proposal, index) => {
        var _a, _b;
        const entry = staticEntries[index];
        if (!entry)
            return null;
        const [id, content] = entry;
        const objectId = (_b = (_a = proposal.proposal_id) !== null && _a !== void 0 ? _a : proposal.proposal_object_id) !== null && _b !== void 0 ? _b : '';
        return buildOneCard(id, objectId, content, proposal, options);
    })
        .filter((card) => card !== null);
}
